import PropTypes from "prop-types"
import { useRef } from "react"

import { useIntersection } from "helpers/use-intersection"
import { cn } from "styles/utils"

const IntersectionWrapper = ({
  children,
  className = "",
  disabled = false,
  ...props
}) => {
  const ref = useRef()
  const inViewport = useIntersection(ref, "200px")
  return (
    <div className={cn("min-h-50", className)} ref={ref} {...props}>
      {(disabled || inViewport) && children}
    </div>
  )
}

IntersectionWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export default IntersectionWrapper
